import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-bring_to_front",
  "use": "icon-bring_to_front-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-bring_to_front\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M10,13H6V12h4Zm3,0h4V12H13ZM6,6V7H17V6Zm6,3.4L13.62,11l.71-.71L11.5,7.48,8.67,10.31l.71.71L11,9.4V14H6v3H17V14H12Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol